export default {
  message: {
    hello: 'Hello world!'
  },
  createAccount: {
    signinTitle: 'Create your account MoIP, it\'s free!'
  }
}



// WEBPACK FOOTER //
// ./src/language/en.js